var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShowMenuItem)?_c('MenuItem',{staticClass:"h11-links",attrs:{"data-qa":"get-tender-protocol","disabled":_vm.loading,"icon":"graph","label":_vm.$t('Tenders.TenderProtocol')},on:{"click":_vm.getTenderProtocol}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }